<template>
    <card title="Ziperase Privacy Policy">
        <p>Effective 22nd March 2024</p>
        <p>Ziperase is a trade name used by Ziperase LLC in the United States of America
            and Ziperase Ltd. in the United Kingdom. This privacy policy will explain
            how our organizations use the personal data we collect from you when you use
            our website at portal.ziperase.com.</p>
        <h2>What data do we collect?</h2>
        <p>Ziperase collects the following data:<br />
            Personal identification information (Name, email address, phone number,
            etc.)<br />
            Cookies and website usage information</p>
        <h2>How do we collect your data?</h2>
        <p>You directly provide Ziperase with most of the data we collect. We collect
            data and process data when you:<br />
            Request information about our products and services.<br />
            Register online or place an order for any of our products or services.<br />
            Voluntarily complete a customer survey or provide feedback on any of our
            message services or via email.<br />
            Use or view our website via your browser’s cookies.</p>
        <h2>How will we use your data?</h2>
        <p>Ziperase collects your data so that we can:<br />
            Process your order and manage your account.<br />
            Email you with special offers on other products and services we think you
            might like.<br />
            Email you with information about product upgrades and security updates</p>
        <p>When Ziperase processes your order, it may send your data to, and also use
            the resulting information from, credit reference agencies to prevent
            fraudulent purchases.</p>
        <h2>How do we store your data?</h2>
        <p>Ziperase securely stores your data at Amazon Web Services and Hubspot.</p>
        <p>Ziperase will keep your personal information for up to ten years. Once this
            time period has expired, we will delete your data by removing it from any
            databases and web services we use.</p>
        <h2>Marketing</h2>
        <p>Ziperase would like to send you information about products and services of
            ours that we think you might like, as well as those of our partner
            companies. If you have agreed to receive marketing, you may always opt out
            at a later date.</p>
        <p>You have the right at any time to stop Ziperase from contacting you for
            marketing purposes. If you no longer wish to be contacted for marketing
            purposes, please contact us.</p>
        <h2>What are your data protection rights?</h2>
        <p>Ziperase would like to make sure you are fully aware of all of your data
            protection rights. Every user is entitled to the following:</p>
        <p>The right to access – You have the right to request Ziperase for copies of
            your personal data. We may charge you a small fee for this service.</p>
        <p>The right to rectification – You have the right to request that Ziperase
            correct any information you believe is inaccurate. You also have the right
            to request Ziperase to complete the information you believe is incomplete.
        </p>
        <p>The right to erasure – You have the right to request that Ziperase erase your
            personal data, under certain conditions.</p>
        <p>The right to restrict processing – You have the right to request that
            Ziperase restrict the processing of your personal data, under certain
            conditions.</p>
        <p>The right to object to processing – You have the right to object to
            Ziperase’s processing of your personal data, under certain conditions.</p>
        <p>The right to data portability – You have the right to request that Ziperase
            transfer the data that we have collected to another organization, or
            directly to you, under certain conditions.</p>
        <p>If you make a request, we have one month to respond to you. If you would like
            to exercise any of these rights, please contact us.<br />
        <h2>Cookies</h2>
        Cookies are text files placed on your computer to collect standard Internet
        log information and visitor behavior information. When you visit our
        websites, we may collect information from you automatically through cookies
        or similar technology. For further information, visit allaboutcookies.org.
        </p>
        <h2>How do we use cookies?</h2>
        <p>Ziperase uses cookies in a range of ways to improve your experience on our
            website, including:<br />
            Keeping you signed in<br />
            Understanding how you use our website<br />
            Personalizing your experience<br />
            For third-party services that we use to analyze and perform business-related
            activities</p>
        <h2>What types of cookies do we use?</h2>
        <p>Our website uses three types of cookies:<br />
            Functionality – Ziperase uses these cookies so that we recognize you on our
            website and remember your previously selected preferences. These could
            include what language you prefer and location you are in. A mix of
            first-party and third-party cookies are used.<br />
            We may use third-party Service Providers to monitor and analyze the use of
            our Service.<br />
            Google Analytics<br />
            Google Analytics is a web analytics service offered by Google that tracks
            and reports website traffic. Google uses the data collected to track and
            monitor the use of our Service. This data is shared with other Google
            services. Google may use the collected data to contextualize and personalize
            the ads of its own advertising network.<br />
            You can opt-out of having made your activity on the Service available to
            Google Analytics by installing the Google Analytics opt-out browser add-on.
            The add-on prevents Google Analytics JavaScript (ga.js, analytics.js, and
            dc.js) from sharing information with Google Analytics about visits
            activity.<br />
            For more information on the privacy practices of Google, please visit the
            Google Privacy &amp; Terms web page: https://policies.google.com/privacy</p>
        <h2>How to manage cookies</h2>
        <p>You can set your browser not to accept cookies, and the above website tells
            you how to remove cookies from your browser. However, in a few cases, some
            of our website features may not function as a result.</p>
        <h2>Privacy policies of other websites</h2>
        <p>The Ziperase website contains links to other websites. Our privacy policy
            applies only to our website, so if you click on a link to another website,
            you should read their privacy policy.</p>
        <h2>Changes to our privacy policy</h2>
        <p>Ziperase keeps its privacy policy under regular review and places any updates
            on this web page. This privacy policy was last updated on 1st May 2021.</p>
        <h2>How to contact us</h2>
        <p>If you have any questions about Ziperase’s privacy policy, the data we hold
            on you, or you would like to exercise your data protection rights, please
            contact us by email info@ziperase.com</p>
    </card>
</template>
<script>
import Card from './Cards/Card';

export default {
    name: "PrivacyNotice",
    components: {
        Card
    },
};
</script>
